import Button from './Button'
import { ButtonProps } from './types'

export function ButtonSecondary({ children, ...rest }: ButtonProps): React.ReactElement {
  return (
    <Button
      className={
        'ring-2 ring-purple lg:hover:ring-purple-dark ' +
        'focus:ring-8 lg:focus:ring-purple-light lg:disabled:ring-purple ' +
        'text-purple-focus lg:hover:text-purple-dark ' +
        'lg:disabled:text-purple focus:text-purple-focus'
      }
      {...rest}
    >
      {children}
    </Button>
  )
}
